<template lang="pug">
  .FaceFeatureList( ref="area")
    .feature.title
      .feature_key.title.aml auto_ml feature
      .feature_val.title.aml value
      .feature_con.title.aml -

    .feature(v-for="(value, key) in auto_ml")
      .feature_key {{ key }}
      .feature_val {{ value }}

    .feature.title
      .feature_key.title detect feature
      .feature_val.title value
      .feature_con.title confidence

    .feature_group(v-for="(valueGroup, keyf) in featureGroups")
      .feature_group_title {{ toTitle(keyf) }}

      .feature(v-for="(value, key) in valueGroup")
          .feature_key {{ key }}
          .feature_val( :class="{ doubtful: hasDoubt(value.confidence) }") {{ value.value }}
            .swatch(v-if="hasColor(key)" :style="{ backgroundColor: '#' + value.value}")
          .feature_con {{ value.confidence }}





</template>

<script>
  import {
    MODAL_STATES,
    PATHS,
    APP_NAME,
    GETTERS,
    ACTIONS,
    MUTATIONS,
    STATES
  } from 'src/config/app'
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import { TweenLite } from 'gsap'
  import {EVENTS, default as FaceFeatureService} from "src/services/FaceFeatureService/FaceFeatureService"
  import {FeatureGroups} from 'src/services/FaceFeatureService/data/FeatureData'
  import $ from "jquery"

  let _featureGroups = {}
  for (let g in FeatureGroups){
    _featureGroups[g]={}
    for (let f of FeatureGroups[g]){
      _featureGroups[g][f] = {name:f,  value:'', confidence:0,}
    }
  }


  export default {
    name: 'FaceFeatureList',
    components: {
    },
    data() {
      return {
        hasData:false,
        features:{
          bananas:{value:"8 foot bunch", confidence:1}
        },

        featureGroups:_featureGroups,

        auto_ml:{
          hair_texture:'',
          hair_fringe:'',
          hair_shape:'',
          hair_male_length:'',
          hat:'',
          glasses:''
        }
      }
    },
    props: {},
    computed: {
    },

    mounted() {
      FaceFeatureService.on(EVENTS.faceInfo, this.onFaceInfo)
    },

    beforeDestroy() {},

    methods: {
      ...mapMutations(APP_NAME, [
        MUTATIONS.setAppState,
        MUTATIONS.setModalState
      ]),

      hasDoubt(val){
        return (parseFloat(val) < 0.06)
      },

      hasColor(key){
        if (!key){return false}
        if (key === 'hair_color_type'){return false}
        return (key.indexOf('color')> -1)
      },

      toTitle(string){
        if (!string){ return "" }
        return string.split('_').join(' ')
      },

      onFaceInfo(info){
        this.face_info = info
        this.hasData = !!this.face_info
        this.features = {}
        if (!info) {return}
        var fg = this.featureGroups
        var f = info.features

        //set flat list
        for (let k in f){this.features[k] = Object.assign({}, f[k])}

        //set grouped list
        for (let g in this.featureGroups){
          for (let k in this.featureGroups[g]){
            let d = this.features[k] || {value:"undefined" , confidence:0 }
            let o = this.featureGroups[g][k]
            o.value = d.value || "undefined"
            o.confidence = d.confidence || 0
          }
        }

        let hs = FaceFeatureService.hairAssetModel
        let female = FaceFeatureService.faceAssets.female

        this.auto_ml.hair_texture = hs.texture
        this.auto_ml.hair_fringe = hs.fringe
        this.auto_ml.hair_shape = hs.shape
        this.auto_ml.hair_male_length = (female) ? '' : hs.male_length
        this.auto_ml.glasses = FaceFeatureService.faceAssets.aml_glasses
        this.auto_ml.hat = FaceFeatureService.faceAssets.aml_hat

      },


    },

    watch: {},
  }
</script>

<style lang="sass">
  @import "src/styles/common.sass"

  .FaceFeatureList
    background-color:  rgba(235,235,235,1.0)
    font-size: 11px
    position: relative
    display: block
    text-align: left
    min-width: 100%
    width: 370px

    .mobile &
      font-weight: bold

    .feature_group
      position: relative
      display: block

    .feature_group_title
      line-height: 30px
      position: relative
      display: block
      text-align: left
      //text-transform: uppercase
      position: relative
      display: block
      padding: 0px 10px
      width: 100%
      color: white
      background-color: black


    .feature
      position: relative
      display: block
      line-height: 30px
      width: 800px

      &.title
        line-height: 40px




      .feature_key
        width: 130px
        text-align: right
        background-color: #cccccc
        position: relative
        display: inline-block
        padding: 0px 10px

        &.title
          color: white
          background-color: #000000

        &.title.aml
          background-color: #990000

      .feature_val
        text-align: left
        position: relative
        display: inline-block
        padding: 0px 10px
        width: 130px

        &.doubtful
          background-color: #f91b52

        &.title
          color: white
          background-color: #3b3b3b
          //width: 600px

        &.title.aml
          background-color: #990000

        .swatch
          position: relative
          display: inline-block
          margin: 0px 10px
          background-color: rgba(0, 0, 0, 0.71)
          width: 24px
          height: 24px
          vertical-align: middle

      .feature_con
        text-align: left
        position: relative
        display: inline-block
        padding: 0px 10px
        width: 200px

        &.title
          color: white
          background-color: #2b2b2b

        &.title.aml
          background-color: #990000


</style>
